export default __webpack_public_path__ + "static/media/licences.b48d80c9.txt";